module.exports = __webpack_public_path__ + "static/img/1819aba25cff60cd183daec5b88bc426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Download-1.png
// module id = 3vx0
// module chunks = 1